import { render, staticRenderFns } from "./MediaFile.vue?vue&type=template&id=eba99422"
import script from "./MediaFile.vue?vue&type=script&lang=ts"
export * from "./MediaFile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports